import CloseIcon from "@mui/icons-material/Close";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutline";
import ModeEditOutlineOutlinedIcon from "@mui/icons-material/ModeEditOutlineOutlined";
import {
  Box,
  Button,
  Grid,
  Modal,
  TableCell,
  TableRow,
  Typography,
  styled,
  tableCellClasses,
} from "@mui/material";
import { Formik } from "formik";
import React, { useState } from "react";
import { useMutation } from "react-query";
import { v4 as uuid } from "uuid";
import { object, string } from "yup";
import SideSwich from "../../components/switch/SideSwich";
import { GetCitiesResponse } from "../../models/basicInformation.model";
import { EditSupplierUsers } from "../../services/report.service";
import AutoCompleteSearch from "../dropdown/AutoCompleteSearch";
import MaterialTextFieldComponent from "../textField/MaterialTextFieldCmp";

interface Props {
  userFirstname: string;
  userLastname: string;

  mobileNo: string;
  city?: string;
  superUser: boolean;
  active: boolean;
  citiesList: GetCitiesResponse[];
  editModal?: boolean;
  supplierId?: string;
  userId?: number;
  deleteByService?: boolean;
  setDelUserId?: any;
  delUserId?: any;
  setTempUsers?: any;
  tempUsers?: any;
  setReloadOnEdit?: any;
  setReloadOnDel?: any;
  cityId?: number;
}

const StyledTableCell = styled(TableCell)(() => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#EDEFEF",
    color: "#1D4A87",
    fontWeight: "700",
    fontSize: 14,
    textAlign: "center",
    marginBottom: "0.5rem",
    overflowX: "auto",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    textAlign: "center !important",
    overflowX: "auto",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  // "&:nth-of-type(even)": {
  //   backgroundColor: theme.palette.action.hover,
  // },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

const deactiveUserStyle = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",

  minWidth: {
    xs: 250,
    sm: 300,
    md: 400,
    lg: "400px",
  },
  maxHeight: "70vh",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  overflow: "auto",
  overflowX: "hidden",
  paddingRight: "3vh",
  paddingTop: "3vh",
  // direction: "ltr",
  "&::-webkit-scrollbar": {
    width: 7,
  },
  "&::-webkit-scrollbar-track": {
    backgroundColor: "#F9FAFC",
    border: "2px solid #DAE0E4",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "#9AAFC4",
  },
};

const SupplierUsersTable = ({
  userFirstname,
  userLastname,
  mobileNo,
  city,
  superUser,
  active,
  citiesList,
  editModal = true,
  supplierId,
  userId,
  deleteByService = true,
  delUserId,
  setDelUserId,
  setTempUsers,
  tempUsers,
  setReloadOnEdit,
  setReloadOnDel,
  cityId,
}: Props) => {
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [cityIds, setCityIds] = React.useState<number>(0);
  const [editedCity, setEditedCity] = React.useState<any>();
  const [editUsers, setEditUsers] = useState<boolean>();
  const [DeleteUser, setDeleteUser] = useState<boolean>();

  function changeCityIds(e: any, value: any) {
    setCityIds(e);

    setEditedCity(value);
  }
  let initialValues: any = {
    userFirstname: userFirstname,
    userLastname: userLastname,
    mobileNo: "",
    city: city,
    isSuperUser: superUser,
    isActive: active,
  };

  const usersValidation = object().shape({
    userFirstname: string()
      .ensure()
      .required("لطفا نام را وارد نمایید.")
      .matches(/^(?!\s+$).*/, "لطفا نام را صحیح وارد نمایید")

      .max(250, "نام نباید بیشتر از ۲۵۰ باشد"),
    userLastname: string()
      .ensure()
      .required("لطفا نام خانوادگی را وارد نمایید.")
      .matches(/^(?!\s+$).*/, "لطفا نام خانوادگی را صحیح وارد نمایید")
      .max(250, "نام خانوادگی نباید بیشتر از ۲۵۰ باشد"),
  });

  const { mutate: EditSupplierUserMutate } = useMutation(EditSupplierUsers, {
    onSuccess: (data: boolean) => {
      if (data) {
        setEditUsers(data);
        setReloadOnEdit(uuid());
      }
    },
    onError: () => {},
  });

  // const { mutate: DeleteSupplierUsersMutate } = useMutation(
  //   DeleteSupplierUsers,
  //   {
  //     onSuccess: (data: boolean) => {
  //       if (data) {
  //         toast.success("کاربر حذف گردید.");
  //         setDeleteUser(data);
  //         setReloadOnDel(uuid());
  //       }
  //     },
  //     onError: () => {},
  //   }
  // );

  const handleEditUser = (values: any) => {
    EditSupplierUserMutate({
      id: userId!,
      firstName: values.userFirstname.trim(),
      lastName: values.userLastname.trim(),
      cityId: cityIds ? cityIds : cityId!,
      isSuperUser: values.isSuperUser,
      isActive: values.isActive,
      permissions: values.permissions.id,
    });

    setOpenEditModal(false);
  };

  const handleDel = () => {
    // deleteByService
    //   ? DeleteSupplierUsersMutate({
    //       id: userId!,
    //     })
    //   :
    setTempUsers(tempUsers.filter((user: any) => user.userId !== userId));

    setOpenDeleteModal(false);
  };

  return (
    <>
      <StyledTableRow>
        {userFirstname !== undefined &&
          (userFirstname === "" ? (
            <StyledTableCell align="center">
              <p style={{ textAlign: "center", marginBottom: "-.5vh" }}>----</p>
            </StyledTableCell>
          ) : (
            <StyledTableCell scope="row">{userFirstname}</StyledTableCell>
          ))}
        {userLastname !== undefined &&
          (userLastname === "" ? (
            <StyledTableCell align="center">
              <p style={{ textAlign: "center", marginBottom: "-.5vh" }}>----</p>
            </StyledTableCell>
          ) : (
            <StyledTableCell scope="row">{userLastname}</StyledTableCell>
          ))}
        {mobileNo !== undefined &&
          (mobileNo === "" ? (
            <StyledTableCell align="center">
              <p style={{ textAlign: "center", marginBottom: "-.5vh" }}>----</p>
            </StyledTableCell>
          ) : (
            <StyledTableCell align="right">{mobileNo}</StyledTableCell>
          ))}
        {city !== undefined &&
          (city === "" ? (
            <StyledTableCell align="center">
              <p style={{ textAlign: "center", marginBottom: "-.5vh" }}>----</p>
            </StyledTableCell>
          ) : (
            <StyledTableCell align="right">{city}</StyledTableCell>
          ))}
        {superUser !== undefined &&
          (superUser ? (
            <StyledTableCell align="center">
              <p style={{ textAlign: "center", marginBottom: "-.5vh" }}>
                دسترسی کامل
              </p>
            </StyledTableCell>
          ) : (
            <StyledTableCell align="right">
              <p style={{ textAlign: "center", marginBottom: "-.5vh" }}>
                دسترسی محدود
              </p>
            </StyledTableCell>
          ))}
        {active ? (
          <StyledTableCell align="center">
            <p
              style={{
                textAlign: "center",
                marginBottom: "-.5vh",
                color: "#28A745",
              }}
            >
              فعال
            </p>
          </StyledTableCell>
        ) : (
          <StyledTableCell align="right">
            <p
              style={{
                textAlign: "center",
                marginBottom: "-.5vh",
                color: "#E6123D",
              }}
            >
              غیرفعال
            </p>
          </StyledTableCell>
        )}

        <StyledTableCell align="right">
          <span style={{ textAlign: "center", marginBottom: "-.5vh" }}>
            {editModal && (
              <ModeEditOutlineOutlinedIcon
                onClick={() => setOpenEditModal(true)}
                style={{
                  color: "#1D4A87",
                  cursor: "pointer",
                  marginInline: "3px",
                }}
              />
            )}
            {!deleteByService && (
              <DeleteOutlineOutlinedIcon
                onClick={() => setOpenDeleteModal(true)}
                style={{
                  color: "#1D4A87",
                  cursor: "pointer",
                  marginInline: "3px",
                }}
              />
            )}
          </span>
        </StyledTableCell>
      </StyledTableRow>
      {/* delete modal */}
      <div>
        <Modal
          open={openDeleteModal}
          onClose={() => setOpenDeleteModal(false)}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={deactiveUserStyle}>
            <Box position={"relative"}>
              <Typography
                onClick={() => setOpenDeleteModal(false)}
                component={"p"}
                color={"red"}
                position={"absolute"}
                top={0}
                left={0}
                sx={{ cursor: "pointer" }}
              >
                <CloseIcon></CloseIcon>
              </Typography>
            </Box>
            <Typography
              component={"p"}
              display={"block"}
              textAlign={"center"}
              fontWeight={"bold"}
              marginY={"3rem"}
              fontSize={"14px"}
            >
              آیا از <span style={{ color: "#E6123D" }}>حذف کردن </span>
              این
              <span style={{ color: "#E6123D" }}> کاربر </span> اطمینان دارید؟
            </Typography>
            <Grid container justifyContent={"center"} gap={"1rem"}>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={6}
                sx={{
                  backgroundColor: "#E6123D",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
                padding={"0.5rem"}
                maxWidth={"150px !important"}
              >
                <Typography
                  textAlign={"center"}
                  color={"#FFF"}
                  fontWeight={"bold"}
                  onClick={handleDel}
                >
                  حذف کردن کاربر
                </Typography>
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={6}
                sx={{
                  backgroundColor: "#607D8B",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
                padding={"0.5rem"}
                maxWidth={"150px !important"}
              >
                <Typography
                  textAlign={"center"}
                  color={"#FFF"}
                  fontWeight={"bold"}
                  onClick={() => setOpenDeleteModal(false)}
                >
                  انصراف
                </Typography>
              </Grid>
            </Grid>
          </Box>
        </Modal>
      </div>
      {/* edit modal */}
      <div>
        <Modal
          open={openEditModal}
          onClose={() => setOpenEditModal(false)}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={deactiveUserStyle}>
            <Box position={"relative"}>
              <Typography
                onClick={() => setOpenEditModal(false)}
                component={"p"}
                color={"red"}
                position={"absolute"}
                top={0}
                left={0}
                sx={{ cursor: "pointer" }}
              >
                <CloseIcon></CloseIcon>
              </Typography>
            </Box>
            <Typography
              component={"p"}
              display={"block"}
              textAlign={"right"}
              fontWeight={"bold"}
              marginY={"3rem"}
              fontSize={"14px"}
              color={"#1D4A87"}
              sx={{ marginBottom: "20px !important" }}
            >
              ویرایش اطلاعات کاربر
            </Typography>
            <Formik
              initialValues={initialValues}
              onSubmit={handleEditUser}
              validateOnMount={true}
              validationSchema={usersValidation}
            >
              {({
                handleSubmit,
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
              }) => (
                <form onSubmit={handleSubmit}>
                  <Grid
                    container
                    justifyContent={"start"}
                    alignItems={"center"}
                  >
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={6}
                      lg={6}
                      marginBottom={"15px"}
                      maxWidth={350}
                    >
                      <MaterialTextFieldComponent
                        placeHolder={"نام"}
                        label={"نام"}
                        required={true}
                        name={"userFirstname"}
                        id={"userFirstname"}
                        value={values.userFirstname}
                        className={"user-edit-input"}
                        onChange={handleChange}
                        helperText={
                          touched.userFirstname ? errors.userFirstname : ""
                        }
                        error={
                          touched.userFirstname && Boolean(errors.userFirstname)
                        }
                        onBlur={handleBlur}
                      />
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={6}
                      lg={6}
                      marginBottom={"15px"}
                      maxWidth={350}
                    >
                      <MaterialTextFieldComponent
                        placeHolder={"نام خانوادگی"}
                        label={"نام خانوادگی"}
                        required={true}
                        name={"userLastname"}
                        id={"userLastname"}
                        value={values.userLastname}
                        className={"user-edit-input"}
                        onChange={handleChange}
                        helperText={
                          touched.userLastname ? errors.userLastname : ""
                        }
                        error={
                          touched.userLastname && Boolean(errors.userLastname)
                        }
                        onBlur={handleBlur}
                      />
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={6}
                      lg={6}
                      marginBottom={"15px"}
                    >
                      <MaterialTextFieldComponent
                        placeHolder={"شماره موبایل"}
                        label={"شماره موبایل"}
                        required={true}
                        name={"mobileNo"}
                        id={"mobileNo"}
                        value={mobileNo}
                        className={
                          "user-edit-input disableForm supplierUsers-edit-mobile"
                        }
                      />
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={6}
                      lg={6}
                      marginBottom={"23px"}
                      className="edit-user-search"
                    >
                      <AutoCompleteSearch
                        label={"استان و شهر محل فعالیت"}
                        name={`city`}
                        id={`city`}
                        value={cityId}
                        options={citiesList}
                        onChange={changeCityIds}
                        responseValue={editedCity}
                        defaultValue={{ id: cityId, title: city }}
                      />
                    </Grid>
                    <Grid
                      item
                      xs={8}
                      sm={8}
                      md={4}
                      lg={6}
                      className="suppliersUsers-switch"
                    >
                      <SideSwich
                        Label={"سطح دسترسی"}
                        checked={superUser}
                        onChange={(checked: boolean = false) => {
                          values.isSuperUser = checked;
                        }}
                        onlabel={"کامل"}
                        offlabel={"محدود"}
                      />
                    </Grid>
                    <Grid
                      item
                      xs={8}
                      sm={8}
                      md={4}
                      lg={6}
                      className="suppliersUsers-switch"
                    >
                      <SideSwich
                        Label={"وضعیت کاربر"}
                        checked={active}
                        onChange={(checked: boolean = false) => {
                          values.isActive = checked;
                        }}
                        onlabel={"فعال"}
                        offlabel={"غیر فعال"}
                      />
                    </Grid>
                  </Grid>
                  <Grid item xs={12} sm={6} md={6} lg={3} xl={3}>
                    <Grid
                      container
                      justifyContent={"center"}
                      alignItems={"center"}
                      gap={1}
                      marginBottom={"8px"}
                      marginTop={"20px"}
                    >
                      <Grid item xs={0} sm={0} md={0} lg={5}></Grid>
                      <Grid item xs={3} width={"100%"}>
                        <Button
                          fullWidth
                          type="submit"
                          variant="contained"
                          // disabled={
                          //   (values.userFirstName === userFirstname &&
                          //     values.userLastName === userLastname) ||
                          //   !values.userFirstName ||
                          //   !values.userLastName
                          // }
                          // className={
                          //   (values.userFirstName === userFirstname &&
                          //     values.userLastName === userLastname) ||
                          //   !values.userFirstName ||
                          //   !values.userLastName
                          //     ? "btnForm disabledBtn"
                          //     : "btnForm SuccessDefault"
                          // }
                          className="btnForm SuccessDefault"
                          sx={{ borderRadius: "5px !important" }}
                        >
                          ثبت
                        </Button>
                      </Grid>
                      <Grid item xs={3} width={"100%"}>
                        <Button
                          onClick={() => setOpenEditModal(false)}
                          fullWidth
                          variant="contained"
                          style={{
                            fontSize: "1rem",
                            color: "#fff",
                            height: "40px",
                            background: "#607D8B",
                          }}
                          sx={{ borderRadius: "5px !important" }}
                        >
                          انصراف
                        </Button>
                      </Grid>
                    </Grid>
                  </Grid>
                </form>
              )}
            </Formik>
          </Box>
        </Modal>
      </div>
    </>
  );
};

export default SupplierUsersTable;
